/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Total_BagsInputs */

const en_cargos_total_bags = /** @type {(inputs: Cargos_Total_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Bags`)
};

const es_cargos_total_bags = /** @type {(inputs: Cargos_Total_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolsas totales`)
};

/**
* | output |
* | --- |
* | "Total Bags" |
*
* @param {Cargos_Total_BagsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_total_bags = /** @type {((inputs?: Cargos_Total_BagsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Total_BagsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_total_bags(inputs)
	return es_cargos_total_bags(inputs)
});